const gda = [
  {
    key: 'gdaKey',
    name: 'Global Dining Access',
    path: 'global-dining-access',
    translationKey: 'rga',
    tagging_event_asset: 'header global dining access',
  },
];

const resyRewards = {
  key: 'resyRewards',
  name: 'Resy Rewards',
  path: 'resy-rewards',
  translationKey: 'resy_rewards',
  tagging_event_asset: 'header resy rewards',
};

const gdaModal = {
  key: 'gdaKey',
  name: 'Global Dining Access',
  translationKey: 'rga',
  isGdaModal: true,
};

const concierge = [
  {
    key: 'conciergeReservationsKey',
    name: 'Concierge Reservations',
    path: 'account/concierge-reservations',
    translationKey: 'concierge_reservations',
  },
];

const loggedIn = [
  {
    key: 'reservationsKey',
    name: 'Reservations &amp; Notify',
    path: 'account/reservations-and-notify',
    translationKey: 'reservations_and_notify',
  },
  {
    key: 'profile',
    name: 'Profile',
    path: 'account/profile',
    translationKey: 'profile',
  },
  {
    key: 'lists',
    name: 'Lists',
    path: 'account/lists',
    translationKey: 'lists.title',
  },
  {
    key: 'paymentMethodsKey',
    name: 'Payment Methods',
    path: 'account/payment-methods',
    translationKey: 'payment_methods_title',
  },
  {
    key: 'communicationTitleKey',
    name: 'Communication',
    path: 'account/communication',
    translationKey: 'communication_title',
  },
  {
    key: 'helpAndFeedbackTitleKey',
    name: 'Help & Feedback',
    path: 'account/help-and-feedback',
    translationKey: 'help_and_feedback_title',
  },
];

const loggedOut = [
  {
    key: 'amexOffers',
    name: 'U.S. Card Offers from Amex',
    path: 'https://www.americanexpress.com/en-us/credit-cards/offers/resy/?eep=46100&extlink=resy-homepage-nav-panel',
    translationKey: 'amex_offers',
    tagging_event_asset: 'header exclusive offers',
  },
  {
    key: 'resyCredit',
    name: 'The Resy Credit',
    path: 'resycredit?intlink=us-resy-topnav',
    translationKey: 'resy_credit',
    tagging_event_asset: 'header resy credit',
  },
  {
    key: 'aboutKey',
    name: 'About',
    path: 'about',
    translationKey: 'about',
  },
  {
    key: 'forRestaurantsKey',
    name: 'For Businesses',
    path: 'https://www.resy.com/join/',
    translationKey: 'for_restaurants',
    tagging_event_asset: 'header businesses',
  },
];

export const getLoggedOutMenuItems = ({ isGdaEnabled, isResyRewardsEnabled }) => {
  const items = [...loggedOut];
  if (isGdaEnabled) items.splice(1, 0, gda[0]);
  if (isResyRewardsEnabled) {
    const resyCreditIndex = items.findIndex((item) => item.key === 'resyCredit');
    items.splice(resyCreditIndex + 1, 0, resyRewards);
  }
  return items;
};

export default {
  gda,
  gdaModal,
  resyRewards,
  concierge,
  loggedIn,
  loggedOut,
};
